import { toast } from 'sonner';

import {
    useGetSupplierByIdQuery,
    useUpdateSupplierByIdMutation,
} from '@/features/slice/suppliers';
import { useModal } from '@/hooks';
import { toastError } from '@/utils';

import { SupplierFormType } from '../create.supplier/create-supplier.schema';

export const useEditSupplier = () => {
    const { modalData: supplierId, closeModal } = useModal();

    const { data, isLoading, isError } = useGetSupplierByIdQuery(supplierId);

    const [updateSupplier, { isLoading: isUpdating }] =
        useUpdateSupplierByIdMutation();

    const onSubmit = async (payload: SupplierFormType) => {
        try {
            await updateSupplier({ id: supplierId, ...payload }).unwrap();
            toast.success('Supplier updated successfully');
            closeModal();
        } catch (error) {
            toastError(error, 'useEditSupplier: onSubmit');
        }
    };

    return { data, isLoading, isError, onSubmit, isUpdating };
};
